import { render, staticRenderFns } from "./_base-TooltipIcon.vue?vue&type=template&id=3fad47cf&scoped=true&"
import script from "./_base-TooltipIcon.vue?vue&type=script&lang=js&"
export * from "./_base-TooltipIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fad47cf",
  null
  
)

export default component.exports